import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, OnChanges } from '@angular/core';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { ConstantsModule } from '../constants/constants.module';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { ThrowStmt } from '@angular/compiler';
import { TranslateService } from '@ngx-translate/core';
import { element } from 'protractor';
import { districtsdata , tabledataforstates , setDropDown ,indicatorlist} from 'src/assets/i18n/hi.json';
// import { Event } from 'ngx-bootstrap/utils/facade/browser';


@Component({
  selector: 'app-misfilter',
  templateUrl: './misfilter.component.html',
  styleUrls: ['./misfilter.component.css']
})
export class MisfilterComponent implements OnInit, OnChanges {

  selectedGroup;
  @Output() eventEmitter = new EventEmitter<Object>();
  @Output() datasubmitted = new EventEmitter<Object>();
  @Output() emptyngModel = new EventEmitter<object>();
  @Output() dropdown = new EventEmitter<object>();
  @Output() slectedmonth = new EventEmitter<Object>(); 
  @Output() selectedId = new EventEmitter<Object>();
  @Output() selecteddistId = new EventEmitter<Object>();
  @Output() baseselectedstate = new EventEmitter<Object>();
  @Output() baseselecteddistrict = new EventEmitter<Object>();
  @Input() activeTab: string;
  @Input() selectedlanguage:string;
  @Output() distName= new EventEmitter<Object>();

  filterOptions: object = { year: '', group: [], indicatorarray: '', themearray: '' };
  filterDropDownList: object = { AssesmentYearList: [], GroupList: [], StateList: [], IndicatorList: [], ThemeList: [], Statedropdown: [], DistrictList: [] };
  filterDropDownLists: object = { AssesmentYearList: [], GroupList: [], StateList: [], IndicatorList: [], ThemeList: [], Statedropdown: [], DistrictList: [] };
  Urlparams;
  indicatorlist;
  datasubmit = 'regionwise';
  datasubmitstate = 'statewise';
  monthlist: object = { 'montharray': '' };
  regionList: [];
  filterlist: object = { state: [] }
  datasubmits = 'statewise';
  validation: boolean[] = new Array(2).fill(true);
  activeSpinner: boolean;
  showDropdownstate: boolean = true;
  selectedindicatorState: boolean;
  selectedstate: any;
  SelectedState:any;
  baseselectedlu: any;
  selectedbaseluuid: any;
  selectedlu: any;
  selectedistrict: any;
  showDropdown: boolean = true;
  firstItemEntered:boolean=false;
  itemSelectCount=0;
  Default: object = { assesmentyear: null, group: 'NON HIMALAYAN' }
  onadditem:boolean=false;
  dropdownSettings: any = {
    singleSelection: false,
    idField: 'item_id',
    //textField: (this.selectedlanguage=='en')?"item_text":"item_hindi",
    textField:'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    noDataAvailablePlaceholderText: 'No locations available.',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  hindidropdownSettings:any={
    singleSelection: false,
    idField: 'item_id', 
    textField: 'item_hindi',
    selectAllText: setDropDown.selectAllText,//'सबका चयन करें',
    unSelectAllText: setDropDown.unSelectAllText,//'सभी को अचयनित करें',
    noDataAvailablePlaceholderText: setDropDown.noDataAvailable,//'कोई स्थान उपलब्ध नहीं है.',
    itemsShowLimit: 1,
    allowSearchFilter: true

  }
  dropdownSettingforSmartchart: any = {
    singleSelection: true,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    noDataAvailablePlaceholderText: 'No locations available.',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  dropdownSingle: any = {
    singleSelection: true,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    noDataAvailablePlaceholderText: 'No locations available.',
    itemsShowLimit: 1,
    allowSearchFilter: false
  };
  dropdownSetting: any = {
    singleSelection: false,
    idField: 'uuid',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    noDataAvailablePlaceholderText: 'No locations available.',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };
  hindidropdownSetting: any = {
    singleSelection: false,
    idField: 'uuid',
    textField: 'naam',
    selectAllText: setDropDown.selectAllText,
    unSelectAllText: setDropDown.unSelectAllText,
    noDataAvailablePlaceholderText: setDropDown.noDataAvailable,
    itemsShowLimit: 2,
    allowSearchFilter: true
  };
  stateflag: boolean;
  districtflag: boolean;
  stateDropDownList: any[];
  showdistdropdown: boolean = false;
  dropdownlist: any;
  groupselected: any = undefined;
  showDropdownDistrict: boolean = false;
  DistrictList: any[];
  districtselect: any = undefined;
  ListStates: any[];
  districtarray: any[];
  statefunction: any;
  statearrays: any = [];
  dropdownsState: any;
  datatab: boolean;
  userdetails: any;
  region: never;
  stateArrayList: any[];
  districtArray: any[];
  monthList: any = [
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' },
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
  ];
  stateTranslate:any=[];
  districtTranslate:any=[];  
  monthsList: any;
  selectedMonth: any;
  statelists: any[];
  districtentityList: any[];
  showdistdrop: boolean = false
  filterdistrict: any;
  selectdistrict: any;
  fetchData: any;
  DistrictentityList: any[];
  basestate: any;
  showbasedist: boolean;
  themeEntityList: any[];
  themeentityList: any[];
  indicatorentityList: any[];
  yearDropDownList: any;
  baseDistrictentityList: any[];
  firstdistEntered: boolean=false;
  distSelectCount: number;


  constructor(
    private submitdataservice: SubmitdataService,
    private constants: ConstantsModule,
    private logsrv: AuthloginService,
    private translate: TranslateService,
    public utils: UtilsModule,
    public route: ActivatedRoute,
    private router: Router
  ) {
    translate.setDefaultLang("en");    

  }

  ngOnInit() {
    this.userdetails = this.logsrv.checkloginstatus();
    this.monthsList = this.monthList;
    this.setCurrentMonthDefault();
    // this.getLocationList();
    // this.getLocationLists();
    this.getstateslist();
    if (this.activeTab == 'smartchart') {
      this.Default['group'] = [{ item_id: "20d5931b-d962-4b4f-9fde-08d9db3db3e8", item_text: "NON HIMALAYAN" }];
    }

    this.AddDefaultUrlParams();
    // this.selectOption()

  }
  
  setCurrentMonthDefault(){
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj =>{
      if(parseInt(monthObj['key'])  == currentmonth + 1){
        currentmonthObj = monthObj;
      }
    });
    this.monthlist['montharray'] = currentmonthObj['key'];
    this.slectedmonth.emit(this.monthlist);

  }
  
  getdistuuid(selectedlu) {
    this.selecteddistId.emit(selectedlu);
    this.DistrictentityList.forEach(district=>{
      // console.log(district);
      if (district.uuid == selectedlu){
        let name=district.name;
        this.getdistName(name);
      }
    })
    // this.selectedId = selectedlu;
  }
  getdistName(name){
    this.distName.emit(name);

  }


  ngOnChanges(changes: SimpleChanges): void {
    
    this.monthlist= { 'montharray': '' };
    if (this.activeTab == "customranking") {
      this.getStateList();
    } else {
      //  this.getLocationList();
    }

    if (this.activeTab == 'comparison' || this.activeTab == 'indicatorchart' || this.activeTab == 'themechart'){
      this.Default['group'] = 'NON HIMALAYAN'
      
    }

    if (this.activeTab == "indicatorchart" || this.activeTab == 'themechart' || this.activeTab == "customranking") {
      this.getindicatorData();
      this.getMultiindicatorData();
    }


    this.AddDefaultUrlParams();
    // if(this.activeTab == 'indicatorstatus'){
    //   this.getRegionList();
    // }
  }


  public AddDefaultUrlParams() {

    this.Urlparams = this.utils.getWritableObject(this.route.snapshot.params);

    this.filterDropDownList["AssesmentYearList"] = this.submitdataservice.getassesmentYearForMIs().slice(1)
    this.setyear(this.Urlparams['assesmentyear']);
    this.setgroup(this.Urlparams['group']);
    // this.setComponent(this.Urlparams['component']);
    let urlParams = {}
    urlParams = Object.assign(this.Urlparams);

    this.router.navigate(['/mis', urlParams]);

  }
  private setyear(year) {
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }
    this.submitdataservice.getYearsToDisplay(this.submitdataservice.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
    })
    this.filterOptions['assesmentyear'] = dropDownYear;
  }
  private setgroup(group) {

    let grouparray = [];
    // if(group){
    //   grouparray = this.gisService.convertKeysto(group.split(','),"aot",this.filterDropDownList['GroupList'])
    // }
    if (this.activeTab == 'comparison' || this.activeTab == 'indicatorchart' || this.activeTab == 'themechart') {
      this.filterOptions['grouparray'] = group || this.filterDropDownList['GroupList'][0]['item_id'];
    } else {
      this.filterOptions['grouparray'] = group || [{ "item_id": "20d5931b-d962-4b4f-9fde-08d9db3db3e8", "item_text": "NON HIMALAYAN" }]
    }

  }
  getAssesement() {
    if (this.filterOptions['assesmentyear'] == '2019 - 2020') {
      this.datatab = false
    } else {
      this.datatab = true;
    }
  }
  selectOption(month) {
    // this.selectedMonth = month;
    this.monthlist['montharray'] = month;
    this.slectedmonth.emit(this.monthlist);
    // this.emptyngModel.emit(this.monthlist['montharray']);
    
  }
  typechanged() {
    this.filterOptions['grouparray'] = [];
    if (this.datasubmit == 'regionwise') {
      this.stateflag = false;
      this.showDropdown = true;
      this.showDropdownDistrict = false;
    } else if (this.datasubmit == 'statewise') {
      this.districtflag = true;
      this.showDropdown = false;
      this.showDropdownDistrict = false;
      this.filterOptions['grouparray'] = undefined;
    } else {
      this.showDropdownDistrict = true;
    }
    this.datasubmitted.emit(this.datasubmit);
    this.monthlist = { 'montharray': '' };

    if (this.activeTab == "customranking") {
      this.getindicatorData();
    }
    // if(this.activeTab == 'indicatorchart' &&  this.datasubmit == 'statewise'){
    //   this.getIndicatorLists();
    // }
  }
  dataSubmissionChange() {
  }
  // getIndicatorList(){
  //   if(this.activeTab == "customranking" || this.activeTab=='indicatorchart' || this.activeTab=='themechart'){
  //   this.filterDropDownList['IndicatorList'] = [];
  //   this.filterDropDownList['ThemeList'] = [];
  //   this.filterOptions['indicatorarray'] = '';
  //   this.filterOptions['themearray'] = '';
  //   this.activeSpinner = true;
  //   // if(this.datasubmits == 'statewise'){
  //   let option = {
  //     "ay" : this.filterOptions['assesmentyear']
  //   }

  //   this.submitdataservice.FetchIndicators(option).subscribe(data=>{
  //     if(data.length > 0){
  //       this.indicatorlist = data;
  //       let array = [];
  //       let arr = [];
  //       data.forEach(theme => {
  //         let temp = {};
  //         temp['uuid'] = theme['entityUUID'];
  //         temp['name'] = theme['label'];
  //         arr.push(temp);
  //         this.filterDropDownList['ThemeList'] = this.groupListForMultiDropDown(arr,true);
  //           theme['childList'].forEach(ind => {
  //           let obj = ind;
  //           obj['uuid'] = ind['entityUUID'];
  //           obj['name'] = ind['sno']+' '+ ind['label'];
  //           array.push(obj);
  //           this.filterDropDownList['IndicatorList'] = this.groupListForMultiDropDown(array,false);
  //         });
  //       });
  //     }
  //   var uniqueArray = this.removeDuplicates(this.filterDropDownList['IndicatorList'], "item_id");
  //   this.filterDropDownList['IndicatorList'] = uniqueArray;
  //   });
  // }
  //   this.activeSpinner = false;
  // }
  // getIndicatorLists(){
  //   if(this.activeTab == "customranking" || this.activeTab=='indicatorchart' || this.activeTab=='themechart'){
  //   this.filterDropDownList['IndicatorList'] = [];
  //   this.filterDropDownList['ThemeList'] = [];
  //   this.filterOptions['indicatorarray'] = '';
  //   this.filterOptions['themearray'] = '';
  //   this.activeSpinner = true;
  //   let option = {
  //     "ay" : this.filterOptions['assesmentyear']
  //   }

  //   this.submitdataservice.FetchIndicators(option).subscribe(data=>{
  //     if(data.length > 0){
  //       this.indicatorlist = data;
  //       let array = [];
  //       let arr = [];
  //       data.forEach(theme => {
  //         let temp = {};
  //         temp['uuid'] = theme['entityUUID'];
  //         temp['name'] = theme['label'];
  //         arr.push(temp);
  //         this.filterDropDownList['ThemeList'] = this.groupListForMultiDropDown(arr,true);
  //           theme['childList'].forEach(ind => {
  //           let obj = ind;
  //           obj['uuid'] = ind['entityUUID'];
  //           obj['name'] = ind['sno']+' '+ ind['label'];
  //           array.push(obj);
  //           this.filterDropDownList['IndicatorList'] = this.groupListForMultiDropDown(array,false);
  //         });
  //       });
  //     }
  //   var uniqueArray = this.removeDuplicates(this.filterDropDownList['IndicatorList'], "item_id");
  //   this.filterDropDownList['IndicatorList'] = uniqueArray;
  //   });
  // }
  //   this.activeSpinner = false;
  // }
  //  removeDuplicates(originalArray, prop) {
  //     var newArray = [];
  //     var lookupObject  = {};

  //     for(var i in originalArray) {
  //        lookupObject[originalArray[i][prop]] = originalArray[i];
  //     }

  //     for(i in lookupObject) {
  //         newArray.push(lookupObject[i]);
  //     }
  //      return newArray;
  //   }
  getindicatorData() {
    this.themeentityList = [];
    this.indicatorentityList = [];
    this.activeSpinner = true;
    let postdata = {
      "ay": this.filterOptions['assesmentyear']
    }
    this.submitdataservice.FetchIndicators(postdata).subscribe(result => {
      if (result.length > 0) {
        this.fetchData = this.formatfetchData(result);
        
        let tempind = [];
        let ind = [];
        result.forEach(theme => {
          if (theme['label'] != null && theme['label'] != 'Meeting at DGC ' && theme['label'] != "kbewkhjfojehrf"
           && theme['label'] != 'asdf' && theme['label'] != "jtutiy" && theme['label'] != "ygyigiyg") {
            this.themeentityList.push({ "label": theme['label'], "entityUUID": theme['entityUUID'] })
            theme['childList'].forEach(object => {
              this.indicatorentityList.push({ "label": object['label'],"sno": object['sno'], "entityUUID": object['entityUUID'] });
              
              this.activeSpinner = false;
            });
           }
        });
        
      }
    });
  }
  formatfetchData(data){
    if (data && data.length > 0)
      data.forEach(element => {
        if (element['childList']) {
          element['childList'].forEach(indicator => {
            if (indicator['label'] && indicator['label'] == "Percentage gap between Solid waste generated & solid waste actually treated in the town- across all ULBs within the district") {
              indicator['sno'] = "2.10";
            }
          });
        }
      });
      return this.sortingdata(data);
  }
  sortingdata(data){
    if (data && data.length > 0)
    data.forEach(element => {
      if (element['childList'] && element['childList'].length > 0) {
        element['childList'].sort((a, b) => {
          let sno1 = parseInt(a['sno'].replace('.', ''));
          let sno2 = parseInt(b['sno'].replace('.', ''));
          return sno1 > sno2 ? 1 : -1;
        })
      }
    });
  return data;
  }
  getMultiindicatorData() {
    this.filterDropDownList['IndicatorList'] = [];
    this.filterDropDownList['ThemeList'] = [];
    this.activeSpinner = true;
    let postdata = {
      "ay": this.filterOptions['assesmentyear']
    }
    this.submitdataservice.FetchIndicators(postdata).subscribe(result => {
      if (result.length > 0) {
        this.fetchData = this.formatfetchData(result);
        let tempind = [];
        let ind = [];
        result.forEach(theme => {
          let obj = {};
          obj['uuid'] = theme['entityUUID'];
          obj['name'] = theme['label'];
          ind.push(obj);
          this.filterDropDownList['ThemeList'] = this.groupListForMultiDropDown(ind, true);
          theme['childList'].forEach(ind => {
            let subind = ind;
            subind['uuid'] = ind['entityUUID'];
            subind['name'] = ind['sno'] + ' ' + ind['label'];
            subind['naam'] = ind['sno'] + ' ' + indicatorlist[ind['label']];
            tempind.push(subind);
            this.filterDropDownList['IndicatorList'] = this.groupListForMultiDropDownIndicator(tempind, false);//this.groupListForMultiDropDown(tempind, false);
          });
        });
      }
      var uniqueArray = this.removeDuplicateArray(this.filterDropDownList['IndicatorList'], "item_id");
      this.filterDropDownList['IndicatorList'] = uniqueArray;
    });
    this.activeSpinner = false;
  }
  removeDuplicateArray(originalobj, prop) {
    let newArray = [];
    var lookupObject = {};

    for (var i in originalobj) {
      lookupObject[originalobj[i][prop]] = originalobj[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  getStateList() {
    this.activeSpinner = true;
    let option = {};
    option['pType'] = this.constants.LOCATION_CONSTANT['REGION'];
    option['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    // option['puuid'] = this.constants['COUNTRYUUID']
    // option['type'] = type;
    option["component"] = "";
    option["src"] = "";
    // this.activeSpinner = true;
    this.submitdataservice.getLocationList(option).subscribe(data => {
      if (data) {
        // var data = this.submitdataService.getLocationList();
        let grouparray = [];
        Object.keys(data).forEach((key) => {
          data[key].forEach(list => {
            grouparray.push(list);
            // if(this.showdistdropdown == ''){
            this.filterDropDownList['StateList'] = this.groupListForMultiDropDown(grouparray, true);

          });
        });
      }
      else
        this.filterDropDownList['StateList'] = [];
      this.activeSpinner = false;
    }, function (err) {
      this.activeSpinner = false;
      if (err['error']) {
        this.toastr.error(err['error']['msg'])
      }
    });
  }
  getStateChange() {
  }
  getDistrictChange() {

  }
  getLocationList() {
    let option = {};
    option['pType'] = this.constants.LOCATION_CONSTANT['COUNTRY'];
    option['cType'] = this.constants.LOCATION_CONSTANT['REGION'];
    // option['puuid'] = this.constants['COUNTRYUUID']
    // option['type'] = type;
    option["component"] = "";
    option["src"] = "";
    // this.activeSpinner = true;
    this.submitdataservice.getLocationList(option).subscribe(data => {
      if (data) {
        // var data = this.submitdataService.getLocationList();
        let grouparray = [];
        Object.keys(data).forEach((key) => {
          data[key].forEach(list => {
            grouparray.push(list);
            // if(this.datasubmit == 'regionwise'){
            this.filterDropDownList['GroupList'] = this.groupListForMultiDropDown(grouparray, true);
          });
        });
        this.AddDefaultUrlParams()
      }
      else
        this.filterDropDownList['GroupList'] = [];
      // this.activeSpinner = false;
    }, function (err) {
      this.activeSpinner = false;
      if (err['error']) {
        this.toastr.error(err['error']['msg'])
      }
    });
  }
  getlocationforStateFilter(filterstate) {
    this.dropdownsState = [];
    this.filterDropDownList['Statedropdown'] = [];
    this.statearrays = [];
    this.statefunction = false;
    this.groupselected = filterstate;
    this.selectedstate = undefined;
    this.SelectedState=undefined;
    this.dropdownlist = [];
    const option = {};
    option['pType'] = this.constants.LOCATION_CONSTANT['REGION'];
    option['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    option["component"] = "";
    option["src"] = "";
    this.submitdataservice.getLocationList(option).subscribe(data => {
      if (data) {
        let grouparray = [];
        Object.keys(data).forEach((key) => {
          if (key == filterstate) {
            data[key].forEach(element => {
              grouparray.push(element);
              this.filterDropDownList['Statedropdown'] = this.groupListForMultiDropDown(grouparray, true);
              if (this.datasubmit == 'statewise' && (this.activeTab == 'comparison' || this.activeTab == 'themechart' || this.activeTab == 'indicatorchart')) {
                this.dropdownsState.push(element)
              }

            });
          }

        });

      }
    }, function (err) {
      this.activeSpinner = false;
      if (err['error']) {
        this.toastr.error(err['error']['msg'])
      }
    });
    this.statefunction = true;
  }
  getstateslist() {
    let postdata = {};
    this.stateArrayList = [];
    this.statelists = [];
    this.filterDropDownLists['GroupList']=[];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataservice.getLocationList(postdata).subscribe(data => {
      if (data) {
        this.stateTranslate=[];
        this.filterDropDownList['GroupList']=[];
        Object.keys(data).forEach(key => {
          data[key].forEach(statelist => {
            let obj={key:"" ,value:""};
            this.statelists.push(statelist);
            obj.key=statelist['name'];
            obj.value=""+tabledataforstates[obj.key];
            this.stateTranslate.push(obj);
            this.statelists.sort((a, b) => (a.name > b.name) ? 1 : -1);
            this.filterDropDownLists['GroupList'] = this.groupListForMultiDropDown(this.statelists, true);

          });
        })
      }
    })

    // this.dropdownSettings ={
    //   singleSelection: false,
    //   idField: 'item_id',
    //   textField: (this.selectedlanguage=='en')?"item_text":"item_hindi",
    //   selectAllText: 'Select All',
    //   unSelectAllText: 'UnSelect All',
    //   noDataAvailablePlaceholderText: 'No locations available.',
    //   itemsShowLimit: 1,
    //   allowSearchFilter: true
    // };

  }
  getLocationLists() {
    let option = {};
    this.stateDropDownList = [];
    option['pType'] = this.constants.LOCATION_CONSTANT['REGION'];
    option['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    option["component"] = "";
    option["src"] = "";
    this.activeSpinner = true;
    this.submitdataservice.getLocationList(option).subscribe(data => {
      if (data) {
        // var data = this.submitdataService.getLocationList();
        Object.keys(data).forEach((key) => {
          data[key].forEach(list => {
            this.stateDropDownList.push(list);
          });
        });
        // this.stateDropDownList.sort(this.submitdataservice.sortStates("name"))
      }
      else
        this.stateDropDownList = [];
      this.activeSpinner = false;
    }, function (err) {
      this.activeSpinner = false;
      if (err['error']) {
        this.toastr.error(err['error']['msg'])
      }
    });
  }
  getLocationForDistrict(stateuuid) {
    this.districtselect = stateuuid;
    this.selectedistrict = undefined;
    this.DistrictList = [];
    let option = {
      'pType': this.constants.LOCATION_CONSTANT['STATE'],
      'cType': this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': (stateuuid != 'null' ? stateuuid : null)
    };
    this.submitdataservice.getLocationListforUser(option).subscribe(data => {
      if (Array.isArray(data)) {
        this.DistrictList = data;
      }

    }, function (err) {
      this.activespineer = false;
      if (err['error']) {
        this.toastr.error(err['error']['msg'])
      }
    })
  }

  groupListForMultiDropDown(data: any, issort: boolean): any {
    let result = [];
    for (let i = 0; i < data.length; i++) {
      if (!data[i]) continue;
      let item = {};
      item['item_id'] = data[i]['uuid'];//id++;
      item['item_text'] = data[i]['name'];
        this.stateTranslate.forEach(obj=>{
          if (obj.key==item['item_text']){
            item['item_hindi']=obj.value;
          }
        })
      // if(tabledataforstates[item['item_text']])
      // {
      //   item['item_hindi']=""+tabledataforstates[item['item_text']];
      // }     
            result.push(item);
    }
    if (issort)
      result.sort((a, b) => (a.item_text > b.item_text) ? 1 : -1);

    return result;
  }
  groupListForMultiDropDownIndicator(data: any, issort: boolean): any {
    let result = [];
    for (let i = 0; i < data.length; i++) {
      if (!data[i]) continue;
      let item = {};
      item['item_id'] = data[i]['uuid'];//id++;
      item['item_text'] = data[i]['name'];
      item['item_hindi']=data[i]['naam'];
            result.push(item);
    }
    if (issort)
      result.sort((a, b) => (a.item_text > b.item_text) ? 1 : -1);

    return result;
  }
  showdistrictdropdown(stateuuid) {
    this.filterdistrict = stateuuid;
    if (stateuuid) {
      this.showdistdrop = true;
    } else {
      this.showdistdrop = false;
    }
    if (this.showdistdrop) {
      this.getDistrictList();
    }
  }
  showdistrictdrop(stateuuid) {
    this.filterdistrict = stateuuid;
    if (stateuuid) {
      this.showdistdrop = true;
    } else {
      this.showdistdrop = false;
    }
    if (this.showdistdrop) {
      this.getDistrictList();
    }
  }
  showdatafordist(stateuuid) {
    this.filterdistrict = stateuuid;
    if (stateuuid) {
      this.showdistdrop = true;
    } else {
      this.showdistdrop = false;
    }
    if (this.showdistdrop) {
      this.getlocationdetails();
    }
    this.selectedId.emit(stateuuid)
  }
  showbasestatedata(basedata) {
    this.basestate = basedata;
    if (basedata) {
      this.showbasedist = true
    } else {
      this.showbasedist = false;
    }
    if (this.showbasedist) {
      this.getbaselocationdetails();
    }
    this.baseselectedstate.emit(basedata);
  }
  getdistbaseuuid(baselu) {
    this.baseselecteddistrict.emit(baselu)
  }
  getbaselocationdetails() {
    this.baseDistrictentityList = []
    let option = {
      'pType': this.constants.LOCATION_CONSTANT['STATE'],
      'cType': this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': this.basestate
    };
    this.activeSpinner = true;
    this.submitdataservice.getLocationListforUser(option).subscribe(data => {
      this.activeSpinner = false;
      if (Array.isArray(data)) {
        this.baseDistrictentityList = data;
        this.baseDistrictentityList.sort((a, b) => (a.name > b.name) ? 1 : -1);
      }
      // else
      //  this.fieldDropDownList['DistrictList'] = [];

    }, function (err) {
      this.activespineer = false;
      if (err['error']) {
        this.toastr.error(err['error']['msg'])
      }
    })
  }
  getlocationdetails() {
    this.DistrictentityList = []
    let option = {
      'pType': this.constants.LOCATION_CONSTANT['STATE'],
      'cType': this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': this.filterdistrict
    };
    this.activeSpinner = true;
    this.submitdataservice.getLocationListforUser(option).subscribe(data => {
      this.activeSpinner = false;
      if (Array.isArray(data)) {
        this.DistrictentityList = data;
        this.DistrictentityList.sort((a, b) => (a.name > b.name) ? 1 : -1);
      }
      // else
      //  this.fieldDropDownList['DistrictList'] = [];

    }, function (err) {
      this.activespineer = false;
      if (err['error']) {
        this.toastr.error(err['error']['msg'])
      }
    })
  }
  getDistrictList() {
    // this.districtentityList = [];
    this.selectdistrict = undefined;
    let postdata = {
      'pType': this.constants.LOCATION_CONSTANT['STATE'],
      'cType': this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': this.filterdistrict
    }
    this.submitdataservice.getLocationListforUser(postdata).subscribe(data => {
      // if (Array.isArray(data)) {
      //   this.districtentityList = data;
      // 
      this.districtTranslate=[];
      this.districtentityList=this.formatDistrcitList(data);
    

    }, function (err) {
      this.activespineer = false;
      if (err['error']) {
        this.toastr.error(err['error']['msg'])
      }
    })
  }

  formatDistrcitList(data){
    let tempData = {};
    data.forEach(dist=>{
      let obj={'name':"",'uuid':"",'naam':""};
      obj['uuid']=dist['uuid'];
      obj['name']=dist['name'];
      obj['naam']=districtsdata[obj['name']];
      this.districtTranslate.push(obj);
    })
    return this.districtTranslate;
  }
  onItemSelect(item: any, type: String) {
    let a=[];
    a[0]=item;
    this.addItem(a,'',type);
    
  }
  onItemDeSelect(item: any, type: String) {
    let a=[];
    a[0]=item;
    this.removeItem(a, '', type);
  }
  onItemDeSelectAll(items: any, type: String) {
    this.removeItem(items, 'all', type);
  }
  onSelectAll(items: any, type: String) {
    this.addItem(items, 'all', type);
  }

  addItem(item, option, type) {
    if (option == 'all') {
      this.filterOptions[type] = [];
    }
    else if(option==''&& (this.firstItemEntered==false)){
      this.firstItemEntered=true;
      this.filterOptions[type] = [];
    }
    for (let i = 0; i < item.length; i++) {
      if (item[i]['item_hindi']){
          let itemobj={}
          itemobj=item[i];
          this.stateTranslate.forEach(obj=>{
            if(item[i]['item_hindi']==obj.value)
            {
              itemobj['item_text']=obj.key;
              item[i]=itemobj;
            }

          })

        }
      this.filterOptions[type].push(item[i]);
      this.itemSelectCount=this.itemSelectCount + 1;
    }  
    this.onadditem=true;  
  }
  removeItem(item, option, type) {
    this.onadditem=false;
    if (option == 'all') {
      this.filterOptions[type] = [];
      this.itemSelectCount=0;
    } 
    else if (option=='') {
      //this.firstItemEntered=false;
      //this.filterOptions[type]=[];
      for (let i = 0; i < this.itemSelectCount; i++) {
        for (let j = 0; j < item.length; j++) {
          if (this.filterOptions[type][i]['item_id'] == item[j]['item_id']) {
            this.filterOptions[type].splice(i, 1)
            this.itemSelectCount=this.itemSelectCount - 1;
          }
        }
    }
    }    
    // else {
    //   for (let i = 0; i < this.filterOptions[type].length; i++) {
          //     for (let j = 0; j < item.length; j++) {
    //       if (this.filterOptions[type][i]['item_id'] == item[j]['item_id']) {
    //         this.filterOptions[type].splice(i, 1)
    //       }
    //     }
    //   }
    // }
  }
  onItemSelects(item: any) {
    let a=[];
    a[0]=item;
    this.addItems(a,'');

    // this.addItems(item, '');
  }
  onItemDeSelects(item: any) {
    let a=[];
    a[0]=item;
    this.removeItems(a, '');
  }
  onItemDeSelectAlls(items: any) {
    this.removeItems(items, 'all');
  }
  onSelectAlls(items: any) {
    this.addItems(items, 'all');
  }
  addItems(item,option)
  {
    if (option == 'all'){
      this.districtArray = [];    
    }
    else if(this.firstdistEntered==false && option==''){
      this.districtArray=[];
      this.firstdistEntered=true;
    }
    if (this.activeTab == 'customranking') {
      for (let i = 0; i < item.length; i++) {
        let itemobj={};
        if (this.selectedlanguage=='hi'){
          itemobj=item[i];
          this.districtTranslate.forEach(obj=>{
            if(item[i]['naam']==obj['naam'])
            {
              itemobj['name']=obj['name'];
              item[i]=itemobj;
            }
  
          })  
        }
        else{
          itemobj=item[i];
          this.districtTranslate.forEach(obj=>{
            if(item[i]['name']==obj['name'])
            {
              itemobj['naam']=obj['naam'];
              item[i]=itemobj;
            }
  
          })  
        }
        this.distSelectCount=this.distSelectCount + 1;
        }
    }
    for (let i = 0; i < item.length; i++) {
      this.districtArray.push(item[i]);
    } 
  }
  removeItems(item, option) {
    this.onadditem=false;
    if (option == 'all') {
      this.districtArray = [];
      this.distSelectCount=0;
    } else {
      // for (let i = 0; i < this.districtarray.length; i++) {
      //   for (let j = 0; j < item.length; j++) {
      //     if (this.districtarray[i]['uuid'] == item[j]['uuid']) {
      //       this.districtarray.splice(i, 1)
      //     }
      //   }
      // }
      
      for(let i=0;i<this.districtArray.length;i++){
        for (let j=0;j<item.length;j++){
          if (this.districtArray[i]['uuid']==item[j]['uuid']){
              this.districtArray.splice(i,1);
              this.distSelectCount=this.distSelectCount-1;
          }
        }

      }
    }
  }


  submitfilter() {
    this.activeSpinner = true;
    // let status = this.activeTab == 'customranking' ? this.basicValidation() : true;
    // if(status){
    let urlParams = {}
    let grouparray = [];
    urlParams = Object.assign(this.Urlparams, this.filterOptions);
    urlParams['group'] = this.datasubmit == 'statewise' ? this.filterOptions['grouparraysingle'] : grouparray;
    if (this.activeTab == 'customranking' && this.onadditem) {
    //   this.districtarray.splice(-1, 1);
    //   this.filterOptions['indicatorarray'].splice(-1,1);
    this.filterOptions['statearray']=this.districtArray;
    }
    if (this.datasubmit == 'statewise' && (this.activeTab == 'comparison' || this.activeTab == 'themechart' || this.activeTab == 'indicatorchart')) {
      this.filterOptions['grouparray'] = this.selectedstate;
    }
    let emittdata = this.filterOptions;
    emittdata['indicatorlist'] = this.fetchData
    emittdata['data'] = this.filterDropDownLists['GroupList'];
    // emittdata['groupdropdown'] = this.filterDropDownList['GroupList']
    this.eventEmitter.emit(emittdata);
    // }
    this.activeSpinner = false;
  }
  basicValidation(): boolean {
    this.validation[0] = this.utils.checkarrayfield(this.filterOptions['statearray'])
    this.validation[1] = this.utils.checkarrayfield(this.filterOptions['indicatorarray'])

    return this.validation[0] && this.validation[1]
  }
  
}
